import React from "react";
import { personalInfo } from "../data/mock";

const Footer = () => {
  const year = new Date().getFullYear();
  const city = personalInfo.location.split(",")[0];

  return (
    <footer className="border-t border-rule py-8">
      <div className="max-w-6xl mx-auto px-6 md:px-10 flex flex-wrap items-center justify-between gap-3">
        <p className="font-mono text-[11px] uppercase tracking-widest text-ink-3">
          © {year} {personalInfo.name}
        </p>
        <p className="font-mono text-[11px] uppercase tracking-widest text-ink-3">
          designed & built in {city}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
